export default __webpack_public_path__ + "static/media/logo_dark.ef0c8977.png";